import React from 'react';
import { Section } from '@prosolve/common-components-ui'
import PrimaryContactBlock from './PrimaryContactBlock';
import ScheduleBlock from './ScheduleBlock';

export default ({
  eventData
}) => {
  
  return (
    <div>
      <Section style={{ width: '320px', padding: '0px' }}>
        <PrimaryContactBlock eventData={eventData} />
        <ScheduleBlock eventData={eventData} />
      </Section>
    </div>
  )
}
